import colors from "assets/theme/base/colors";
import typography from "assets/theme/base/typography";
import boxShadows from "assets/theme/base/boxShadows";

import pxToRem from "assets/theme/functions/pxToRem";

const { transparent, dark, secondary } = colors;
const { size } = typography;
const { buttonBoxShadow } = boxShadows;

const outlined = {
  // NOTE — `color` and `borderColor` are deliberately NOT set here.
  //
  // They used to be pinned to light.main (#e9ecef), and because a
  // styleOverrides slot is applied after MUI's own per-colour styles, that one
  // line painted near-white text on EVERY outlined <Button> in the app — the
  // `color` prop did nothing, since outlinedPrimary/outlinedSecondary below
  // only ever re-coloured the border. Buttons were invisible on white cards,
  // and roughly thirty call sites had grown their own `sx={{ color, borderColor }}`
  // workaround. Leaving both unset lets MUI resolve palette[color].main
  // normally, so `color="dark"`, `"info"`, `"error"` … all behave.
  base: {
    minHeight: pxToRem(42),
    padding: `${pxToRem(12)} ${pxToRem(24)}`,

    "&:hover": {
      opacity: 0.75,
      backgroundColor: transparent.main,
    },

    "&:focus:not(:hover)": {
      boxShadow: buttonBoxShadow.stateOfNotHover,
    },

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(16)} !important`,
    },
  },

  small: {
    minHeight: pxToRem(34),
    padding: `${pxToRem(8)} ${pxToRem(32)}`,
    fontSize: size.xs,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(12)} !important`,
    },
  },

  large: {
    minHeight: pxToRem(49),
    padding: `${pxToRem(14)} ${pxToRem(64)}`,
    fontSize: size.sm,

    "& .material-icon, .material-icons-round, svg": {
      fontSize: `${pxToRem(22)} !important`,
    },
  },

  // MUI's default colour is `primary`, so this slot is what a bare
  // <Button variant="outlined"> gets — and in this app that button is always a
  // neutral secondary action (Cancel / Back / Close / History), never a brand
  // CTA. Pinning it to the dark ink rather than primary.main (#cb0c9f) keeps
  // those reading as neutral instead of turning the app magenta. A button that
  // wants brand colour asks for it: color="info", color="error", and so on.
  primary: {
    backgroundColor: transparent.main,
    color: dark.main,
    borderColor: dark.main,

    "&:hover": {
      backgroundColor: transparent.main,
    },

    "&:focus:not(:hover)": {
      boxShadow: buttonBoxShadow.stateOfNotHover,
    },
  },

  secondary: {
    backgroundColor: transparent.main,
    color: secondary.main,
    borderColor: secondary.main,

    "&:hover": {
      backgroundColor: transparent.main,
    },

    "&:focus:not(:hover)": {
      boxShadow: buttonBoxShadow.stateOfNotHover,
    },
  },
};

export default outlined;
